import type { QueueStatsResponse, Response } from '@/lib/apollo/query/getQueueStats/query'

import type { TransformedData, TransformedQueueStatsData } from './types'

export const toTransformedQueueStatsData = (
  queueStats: QueueStatsResponse,
): TransformedQueueStatsData => ({
  ...queueStats,
})

export const toTransformedData = (response?: Response): TransformedData | undefined =>
  response === undefined ? undefined : toTransformedQueueStatsData(response.getQueueStats)
